/** Product & variant photos: square crop (width ÷ height). */
export const PRODUCT_IMAGE_ASPECT_RATIO = 1;
